import { Inventory } from 'lib/documents/inventory';
import { FormattedSection } from '../paginationSlice';
import {
  initialState,
  PROMIS_SECTIONS,
  PromisSliceReducer,
  submit,
  updatePromisItem,
  validate
} from './promisSlice';

import { PagedQuestionnaireWrapper } from 'features/patient/assessment/_components/questionnaire-paginator';
import { QuestionnairePaginationCombinedGeneralProps } from '../../_components/questionnaire-paginator-types';
import { PromisQuestionnaire } from 'features/patient/_utils/questionnaires';
import { formatQuestionnaireData } from '../cgs/cgs-pagination-combined';

export function PaginationCombinedPromis(
  props: Pick<
    QuestionnairePaginationCombinedGeneralProps<any>,
    'onPageChange' | 'onSectionChange'
  > & { storageKey: string }
) {
  return (
    <PagedQuestionnaireWrapper
      initialState={initialState}
      reducer={PromisSliceReducer}
      getData={state => state.promis}
      actions={{
        updateItem: updatePromisItem,
        formatData,
        submit,
        validate
      }}
      pageTitle={section => PROMIS_SECTIONS[section].instructions ?? ''}
      onSubmitExtraNavigationProps={{
        questionnaireName: 'promis'
      }}
      {...props}
    />
  );
}

function formatData(inData: Inventory, pageLimit: number): FormattedSection[] {
  return formatQuestionnaireData(PromisQuestionnaire, inData, pageLimit);
}
